"use client";

/* eslint-disable jsx-a11y/anchor-has-content */
import SearchModalContext from "hooks-contexts/SearchModalContext";
import { RootState } from "interfaces/generics.type";
import Link from "next/link";
import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import HideIf from "util/HideIf";
import { PRODUCT_PAGE_TYPES } from "util/product/product-constants";
import { b2bUrl } from "util/url/static-urls";
import Toolbar from "../../component/toolbar/Toolbar";
import DesktopHeader from "./DesktopHeader";
import HeaderCarousel from "./HeaderCarousel";
import StickyHeaderDesktop from "./sticky-header-desktop/StickyHeaderDesktop";
import commonStyles from "./style.module.scss";

function HeaderDesktop(props: any) {
  const {
    liveChat, onClickLogin, onClickSignup, setNonStickyAccountPopOverRef,
    openSlideMenu, chat, onHideSlideMenu, showSlideMenu, handleShoppingCartClick,
    infoData,
  } = props;

  const { currentPageType } = useSelector((state: RootState) => state.utils);
  const { businessCustomer } = useSelector((store: RootState) => store.authenticationState);
  const [zIndexClass, setZIndexClass] = useState("");
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
  const ref = useRef();

  function zIndexHandler(withTimeOut = true, unsetStyle = false) {
    // As HomePopover renders for initial 5 seconds. So At 1440 screen size zindex issus is coming
    setZIndexClass(commonStyles.z_index);
    Array.from(ref.current?.children[0].children || [], (liChild) => {
      if (liChild.className.includes("open")) {
        setZIndexClass("");
      } else if (withTimeOut) {
        setTimeout(() => {
          setZIndexClass("");
        }, 5000);
      }
    });

    if (unsetStyle) {
      setZIndexClass("");
    }
  }

  return (
    <SearchModalContext.Provider value={{ isSearchModalOpen, setIsSearchModalOpen }}>
      <HideIf show={!(currentPageType && PRODUCT_PAGE_TYPES.includes(currentPageType))}>
        <DesktopHeader
          liveChat={liveChat}
          onClickLogin={onClickLogin}
          onClickSignup={onClickSignup}
          openSlideMenu={openSlideMenu}
          chat={chat}
          onHideSlideMenu={onHideSlideMenu}
          showSlideMenu={showSlideMenu}
          handleShoppingCartClick={handleShoppingCartClick}
        />
      </HideIf>

      <HeaderCarousel infoData={infoData} />

      <div className={`${commonStyles.header_desktop_container} ${zIndexClass}`}>
        <div className={`${commonStyles.header_desktop} ${zIndexClass} header container-fluid p-lr-0-xs`}>
          <div className={`p-lr-0 ${commonStyles.header_logo}`}>
            <Link
              href={businessCustomer ? b2bUrl : "/"}
              title="Your Gateway to Quality Auto Parts: PartsAvatar"
              aria-label="Parts Avatar">

            </Link>
          </div>
          <StickyHeaderDesktop
            setNonStickyAccountPopOverRef={setNonStickyAccountPopOverRef}
            onClickSignup={onClickSignup}
            onClickLogin={onClickLogin}
            liveChat={liveChat}
            handleShoppingCartClick={handleShoppingCartClick}
            callBack={zIndexHandler}
          />
        </div>
      </div>
      <Toolbar zIndexHandler={zIndexHandler} ref={ref} />
    </SearchModalContext.Provider>
  );
}

export default HeaderDesktop;
